export default class UrlService {

    // base64 url to FileList to append binary in formData
    static urltoFile = async (data) => {
        const { url, fileName, fileMimeType } = data;
        const responseData = await fetch(url)
            .then((res) => res.arrayBuffer())
            .then((buf) => new File([buf], fileName, { type: fileMimeType }));
        return responseData;
    }
}